import axios from '../shared/axios';
// import qs from 'querystring';


export function getContractDashboard(companyid, projectid, contractid) {
    return axios.get(`/api/Dashboard/GetDashboard?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}`);
}